function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.623 10.417l-5.79-6.07L7.595 2.5l3.014 3.16 4.538 4.757-7.552 7.916-1.762-1.847z",
  fill: "currentColor",
  fillRule: "evenodd"
});

const SvgArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20
}, props), _ref);

export default SvgArrowRight;